/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Assistant/user message payload.
 */
export type HookMessageData = {
  /**
   * Message or thinking-block duration in milliseconds, when reported.
   */
  durationMs?: number | undefined;
  /**
   * Message role, e.g. assistant or user.
   */
  role?: string | undefined;
  /**
   * Message text.
   */
  text?: string | undefined;
};

/** @internal */
export type HookMessageData$Outbound = {
  duration_ms?: number | undefined;
  role?: string | undefined;
  text?: string | undefined;
};

/** @internal */
export const HookMessageData$outboundSchema: z.ZodMiniType<
  HookMessageData$Outbound,
  HookMessageData
> = z.pipe(
  z.object({
    durationMs: z.optional(z.number()),
    role: z.optional(z.string()),
    text: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      durationMs: "duration_ms",
    });
  }),
);

export function hookMessageDataToJSON(
  hookMessageData: HookMessageData,
): string {
  return JSON.stringify(HookMessageData$outboundSchema.parse(hookMessageData));
}
